import React from 'react';

function BannerSection({ title, subtitle, description, backgroundId = 'default-banner', backgroundImage }) {
  const bannerStyle = {
    backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight: '320px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '3rem 1rem',
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box',
  };

  return (
    <>
<style>
  {`
    .title-banner {
      padding: 2rem;
      max-width: 100%;
      width: 100%;
      word-break: break-word;
      overflow-wrap: break-word;

      margin: 2rem auto; /* Centraliza horizontalmente e dá espaço do topo */
    }

    .title-banner h1 {
      font-size: 2.5rem;
      font-weight: bold;
      color: white;
      word-break: break-word;
      overflow-wrap: break-word;
      text-align: left; /* ou center se quiser o texto centralizado */
    }

    .title-banner h5,
    .title-banner h6 {
      color: white;
      word-break: break-word;
      overflow-wrap: break-word;
      text-align: left;
    }

    @media (max-width: 768px) {
      .title-banner {
        padding: 1.5rem 1rem;
        margin: 1.5rem auto;
      }

      .title-banner h1 {
        font-size: 1.6rem;
      }

      .title-banner h5 {
        font-size: 1rem;
      }

      .title-banner h6 {
        font-size: 0.95rem;
      }
    }
  `}
</style>

      <div id="backImage" className="banner position-relative" style={bannerStyle}>
        <div className="title-banner" id={backgroundId}>
          <h1>{title}</h1>
          <h5>{subtitle}</h5>
          <h6>{description}</h6>
        </div>
      </div>
    </>
  );
}

export default BannerSection;

